import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.app.usuarios.roles.data = data;
  });
};

const roles = async (store, params = {}) => {
  store.setState((state) => {
    state.app.usuarios.roles.busy = true;
  });

  try {
    const response = await Http.get(`api/roles`, { params });

    store.setState((state) => {
      state.app.usuarios.roles.data = response.data;
      state.app.usuarios.roles.busy = false;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.usuarios.roles.error = error.data || error;
      state.app.usuarios.roles.busy = false;
    });
  }
};

const UsuarioRolesStore = {
  state: () => initialState,
  actions: {
    roles,
    change,
  },
};

export default UsuarioRolesStore;
